<template>
  <main>
    <div class="container">
      <al-notify v-if="bannerText" success name="promotional-banner">
        {{ $t(bannerText) }}
      </al-notify>
      <div class="row">
        <div class="col-full">
          <h1 class="display-lg margin-bottom-md">
            {{ $t('profileHome.greetingHeading', { firstName: firstName }) }} 👋
          </h1>
        </div>
      </div>

      <div class="row">
        <div class="col-full">
          <h2 class="heading-md">
            {{ $t('profileHome.preference') }}
          </h2>
          <al-list card>
            <al-list-item
              v-analytics:click="$EVENTS.MANAGE_SETTINGS"
              name="settings-link"
              @click="$router.push({ name: ROUTES.SETTINGS })">
              <al-icon-text icon="icon-settings" variant="sm" wide name="settings-link-label">
                {{ $t('profileHome.settings') }}</al-icon-text
              >
            </al-list-item>
          </al-list>
        </div>
      </div>

      <div class="row">
        <div class="col-full">
          <h2 class="heading-md">
            {{ $t('profileHome.cardsHeading') }}
          </h2>
          <al-list card class="margin-bottom-sm">
            <al-list-item
              v-analytics:click="$EVENTS.VIEW_ALL_CARDS"
              name="cards-list-link"
              @click="$router.push({ name: ROUTES.LIST_CARDS })">
              <al-icon-text icon="icon-wallet" variant="sm" wide name="cards-list-link-label">
                {{ $t('profileHome.listCards') }}</al-icon-text
              >
            </al-list-item>
          </al-list>
          <al-list card>
            <al-list-item
              v-analytics:click="$EVENTS.ADD_CARD_BUTTON"
              name="add-card-link"
              @click="$router.push({ name: ROUTES.ADD_CARD })">
              <al-icon-text icon="icon-card-add" variant="sm" wide name="add-card-link-label">
                {{ $t('profileHome.addCard') }}</al-icon-text
              >
            </al-list-item>
          </al-list>
        </div>
      </div>

      <div class="row">
        <div class="col-full">
          <h2 class="heading-md">
            {{ $t('profileHome.support') }}
          </h2>
          <al-list card class="margin-bottom-sm">
            <al-list-item
              v-analytics:click="$EVENTS.FREQUENTLY_ASKED_QUESTIONS"
              name="get-faq-link"
              @click="$router.push({ name: ROUTES.FAQ })">
              <al-icon-text icon="icon-faqs" variant="sm" wide name="get-faq-link-label">
                {{ $t('profileHome.frequentlyAskedQuestions') }}
              </al-icon-text>
            </al-list-item>
          </al-list>
          <al-list card>
            <al-list-item
              v-analytics:click="$EVENTS.SUPPORT"
              name="get-support-link"
              @click="$router.push({ name: ROUTES.SUPPORT })">
              <al-icon-text icon="icon-support" variant="sm" wide name="get-support-link-label">
                {{ $t('profileHome.contactUs') }}
              </al-icon-text>
            </al-list-item>
          </al-list>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { AlIconText, AlList, AlListItem, AlNotify } from '@mc-alberta/alcapone'
import { mapActions, mapMutations, mapState } from 'vuex'
import { ACTION, ROUTES } from '@/constants.js'
import * as types from '@/store/mutation-types'

export default {
  name: ROUTES.PROFILE_HOME,
  components: { AlList, AlListItem, AlIconText, AlNotify },
  data() {
    return {
      ROUTES,
      isNewUser: this.$route.params.isNewUser,
      addedNewCard: this.$route.params.addedNewCard
    }
  },
  computed: {
    ...mapState({
      firstName: (state) => state.user.consumer.firstName
    }),
    bannerText() {
      return this.isNewUser ? 'cards.bannerNewUser' : ''
    }
  },
  mounted() {
    this.setAction(ACTION.MANAGE)
    this.resetStepMap()
  },
  methods: {
    ...mapActions(['setAction']),
    ...mapMutations({
      resetStepMap: types.RESET_STEP_MAP
    })
  }
}
</script>
